import report_template_library_component from "@/components/probaworkflows_base_components/ReportTemplateLibrary/ReportTemplateLibrary.vue";

export default {
  name: "ReportTemplates",
  components: {
    ReportTemplateLibrary: report_template_library_component,
  },
  methods: {
    go_to_generate_reports() {
      this.$router.push("/generate_reports/");
    },
    go_to_generated_reports() {
      this.$router.push("/generated_reports/");
    },
  },
};
